<template>
  <v-div
    v-if="article.doi"
    class="DOIInformation"
    border-inverted-bottom-thick
    mt-3
    pb-3
  >
    <h2 class="mb-2 ml-2 font-weight-bold font-smaller">DOI</h2>
    <v-div pl-2 font-smaller>
      <a
        :href="`https://doi.org/${article.doi}`"
        target="_blank"
        rel="noopener"
      >
        <div>{{ article.doi }}</div>
        <span class="d-sr-only">{{ doiLinkAriaLabel }}</span>
        <v-icon small color="primary" aria-hidden="true">{{
          mdiOpenInNew
        }}</v-icon>
      </a>
    </v-div>
  </v-div>
</template>

<script>
import { mdiOpenInNew } from "@mdi/js";
export default {
  name: "DOIInformation",
  props: {
    article: { type: Object, required: true },
  },
  data() {
    return {
      mdiOpenInNew,
    };
  },
  computed: {
    doiLinkAriaLabel() {
      return `D O I: ${this.article.doi} [opens in a new tab]`;
    },
  },
};
</script>

<style>
.DOIInformation a i {
  vertical-align: top;
}
.DOIInformation a div {
  display: inline;
  max-width: calc(100% - 20px);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
